import React, { useState, useEffect } from "react";
import GraphChart from "./GraphChart";
import AppCalander from "./Calander";
import StockBarChart from "./StockBarChart";
import HorizontalChart from "./HorizontalChart";
import "../../../assets/scss/components/analytics.scss";
import { getAnalyticsData } from "../../../services/MyApps/myAppServise";
import {
  calanderDateFormater,
  convertFormater,
  numDifferentiation,
} from "../../utils/dateCalculater";
import ErrorMsg from "../../CommonCompnents/ErrorMsg";
import { progress_bar } from "./generic/genericTypes";
import { errorsMsg } from "../../../Containers/Constants/commenFeatures";
const Analytics = (props) => {
  const { analyticsAppModal, showAnalyticsModal, userId } = props;

  const [isCalendar, setIsCalendar] = useState(false);
  const [today, setToday] = useState({
    frmDt: new Date(),
    toDt: new Date(),
  });
  const [isServerErr, setIsServerErr] = useState({
    successRes: "",
    failedRes: "",
    limitExceeded: "",
  });
  const [anltcs, setAnltcs] = useState([]);
  const [horizontalCharts, setHorizontalCharts] = useState([]);

  const [ordVolData, setOrdVolData] = useState(progress_bar);

  const openCalendarHandler = (val) => {
    setIsCalendar(val);
  };

  const updateToday = (val) => {
    setToday({
      frmDt: val[0],
      toDt: val[1] ? val[1] : val[0],
    });
  };

  const getAnalyticsDataRes = (res) => {
    if (res && res.data) {
      getHorizontalData(res.data.anltcs[0]);
      if (res.data.msg && res.data.msg !== null && res.data.msg !== "") {
        setIsServerErr({
          successRes: "",
          limitExceeded: "",
          failedRes: res.data.msg || errorsMsg.commonError,
        });
      } else {
        setIsServerErr({
          successRes: "",
          limitExceeded: "",
          failedRes: "",
        });
      }
    } else {
      setIsServerErr({
        successRes: "",
        limitExceeded: "",
        failedRes: res.error.errMsg || errorsMsg.commonError,
      });
      setAnltcs([]);
      setHorizontalCharts([]);
      setOrdVolData(progress_bar);
    }
  };

  const getHorizontalData = async (data) => {
    let progressData = JSON.parse(JSON.stringify(progress_bar));
    data.ordVol.forEach((ord) => {
      progressData.forEach((ordVol) => {
        if (ord.key === ordVol.name) {
          ordVol.price = numDifferentiation(parseFloat(ord.val));
        }
      });
    });

    data.ordVolPr.forEach((ord) => {
      progressData.forEach((ordVol) => {
        if (ord.key === ordVol.name) {
          ordVol.percent = parseFloat(ord.val);
        }
      });
    });

    data.ordTrdRto.forEach((ord) => {
      progressData.forEach((ordVol) => {
        if (ord.key === ordVol.name) {
          ordVol.ratio = parseFloat(ord.val).toFixed(2);
        }
      });
    });

    setOrdVolData(progressData);
    setHorizontalCharts(progressData);
    setAnltcs(data);
  };

  const getAnalytics = () => {
    openCalendarHandler(false);
    let dataFrom = {
      frmDt: convertFormater(today.frmDt),
      toDt: convertFormater(today.toDt),
      api_key: analyticsAppModal.analyticsData.apiKey,
    };
    getAnalyticsData(getAnalyticsDataRes, userId, dataFrom);
  };

  useEffect(() => {
    if (analyticsAppModal.isOpen) {
      getAnalytics();
    } else {
      updateToday([new Date(), new Date()]);
      setAnltcs([]);
      setIsServerErr({
        successRes: "",
        limitExceeded: "",
        failedRes: "",
      });
    }
  }, [analyticsAppModal.isOpen]);

  useEffect(() => {
    if (analyticsAppModal.isOpen) {
      getAnalytics();
    }
  }, [today]);

  return (
    <>
      <div id={analyticsAppModal.isOpen ? "show_modal" : "hide_modal"}>
        <div className="mob_analytics_header">
          <p>
            <span className="edel-icon-cube"></span>
            {analyticsAppModal.analyticsData.appNm}
          </p>
          <p>
            <span>
              <i
                className="edel-icon-close"
                onClick={() => {
                  showAnalyticsModal(false, "");
                }}
              ></i>
            </span>
          </p>
        </div>

        <div className="modal_analytics" id="modal_analytics">
          <div className="analytics-modal-content">
            <div className="analytics-container">
              <div className="analytics">
                <div className="side_content">
                  <div className="side_content-wrap">
                    <div className="row1 mob_analytics-header">
                      <p>
                        <span className="edel-icon-cube"></span>
                        {analyticsAppModal.analyticsData.appNm}
                      </p>
                      <div className="closeIcon">
                        <span>
                          <i
                            className="edel-icon-close"
                            onClick={() => {
                              showAnalyticsModal(false, "");
                            }}
                          ></i>
                        </span>
                        <p
                          className="pointer"
                          onClick={() => setIsCalendar(!isCalendar)}
                        >
                          <span className="edel-icon-calendar"></span>
                          {calanderDateFormater(today.frmDt)} -{" "}
                          {calanderDateFormater(today.toDt)}
                        </p>
                      </div>
                    </div>
                    <div class="mob_scrol">
                      <div className="mob_datePicker">
                        <p
                          className="pointer"
                          onClick={() => setIsCalendar(!isCalendar)}
                        >
                          <span className="edel-icon-calendar"></span>
                          {calanderDateFormater(today.frmDt)} -{" "}
                          {calanderDateFormater(today.toDt)}
                        </p>
                      </div>
                      <ErrorMsg isServerErr={isServerErr} />
                      <AppCalander
                        isCalendar={isCalendar}
                        today={today}
                        updateToday={updateToday}
                        openCalendarHandler={openCalendarHandler}
                      />
                      <div className="row3">
                        <div>
                          <p>Total No of API Hits</p>
                          <span>
                            {anltcs && anltcs.ntApiCnt
                              ? numDifferentiation(parseInt(anltcs.ntApiCnt))
                              : 0}
                          </span>
                        </div>
                        <div>
                          <p>No of Orders Placed</p>
                          <span>
                            {anltcs && anltcs.ordCnt
                              ? numDifferentiation(parseInt(anltcs.ordCnt))
                              : 0}
                          </span>
                        </div>
                        <div>
                          <p>Order : Trade Ratio (O:T)</p>
                          <span>
                            {anltcs && anltcs.ntOrdTrdRto
                              ? parseFloat(anltcs.ntOrdTrdRto).toFixed(2)
                              : 0}
                          </span>
                        </div>
                      </div>
                      <div className="row4 border_bottom ">
                        <h6>Order Volume (Segment wise)</h6>
                        <div className="row5">
                          <HorizontalChart
                            horizontalCharts={horizontalCharts}
                          />
                        </div>
                        <div className="progress_bar">
                          {ordVolData
                            ? ordVolData.map((data, i) => {
                                return (
                                  <div key={i} className={data.className}>
                                    <div className="bar-info display-flex">
                                      <div>
                                        <div className="color_code"></div>
                                      </div>
                                      <div>
                                        <p>{data.name}</p>
                                        <span>₹{data.price} </span>
                                        <span>({data.percent} %)</span>
                                        <span>O:T - {data.ratio}</span>
                                      </div>
                                    </div>
                                  </div>
                                );
                              })
                            : null}
                        </div>
                      </div>
                      <GraphChart anltcs={anltcs} today={today} />
                      <div className="row5">
                        <StockBarChart anltcs={anltcs} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Analytics;
